const LOCKED_SESSIONS_KEY = "moo_locked_sessions";

const readLockedSessions = () => {
  try {
    const raw = localStorage.getItem(LOCKED_SESSIONS_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (_e) {
    return {};
  }
};

const writeLockedSessions = (sessions) => {
  try {
    localStorage.setItem(LOCKED_SESSIONS_KEY, JSON.stringify(sessions || {}));
  } catch (_e) {
    // ignore
  }
};

export const getLockedSessions = () => readLockedSessions();

export const getLockedSession = (userId) => {
  if (!userId) return null;
  const sessions = readLockedSessions();
  return sessions[String(userId)] || null;
};

export const setLockedSession = (userId, sessionState) => {
  if (!userId) return;
  const sessions = readLockedSessions();
  sessions[String(userId)] = sessionState;
  writeLockedSessions(sessions);
};

export const clearLockedSession = (userId) => {
  if (!userId) return;
  const sessions = readLockedSessions();
  delete sessions[String(userId)];
  writeLockedSessions(sessions);
};

export const migrateLegacyLockedSession = () => {
  try {
    const legacyLocked = localStorage.getItem("lockedSessionState");
    const legacyFlag = localStorage.getItem("sessionLocked") === "true";
    if (!legacyLocked || !legacyFlag) return;

    const data = JSON.parse(legacyLocked);
    const userId = data?.currentUser?.id;
    if (!userId) return;

    const sessions = readLockedSessions();
    if (!sessions[String(userId)]) {
      const lockReason =
        localStorage.getItem("moo_lock_reason") ||
        data.lockReason ||
        data.lockedBy ||
        null;
      sessions[String(userId)] = {
        ...data,
        lockReason: lockReason || "manual",
      };
      writeLockedSessions(sessions);
    }

    localStorage.removeItem("lockedSessionState");
    localStorage.removeItem("sessionLocked");
    localStorage.removeItem("moo_lock_reason");
  } catch (_e) {
    // ignore
  }
};
